import createIcon from '../../createIcon';

/**
 * @component @name FlashlightOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNzA5NiA0LjY5NTMxVjEuNjk1MzFINi43MDk2MVYyLjg2NTMxTDguNTM5NjEgNC42OTUzMUgxOC43MDk2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjcwOTYgMTAuNjk1M0wxOC43MDk2IDcuNjk1MzFWNi42OTUzMUgxMC41Mzk2TDE2LjcwOTYgMTIuODY1M1YxMC42OTUzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTMuNTE5NjEgMi41MDUzMUwyLjA5OTYxIDMuOTE1MzFMOC43MDk2MSAxMC41MjUzVjIxLjY5NTNIMTYuNzA5NlYxOC41MjUzTDIwLjQ4OTYgMjIuMzA1M0wyMS44OTk2IDIwLjg5NTNMMy41MTk2MSAyLjUwNTMxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlashlightOff = createIcon('FlashlightOff', [
  [
    'path',
    { d: 'M18.7096 4.69531V1.69531H6.70961V2.86531L8.53961 4.69531H18.7096Z', key: '1exwra' },
  ],
  [
    'path',
    {
      d: 'M16.7096 10.6953L18.7096 7.69531V6.69531H10.5396L16.7096 12.8653V10.6953Z',
      key: 'r3o3bq',
    },
  ],
  [
    'path',
    {
      d: 'M3.51961 2.50531L2.09961 3.91531L8.70961 10.5253V21.6953H16.7096V18.5253L20.4896 22.3053L21.8996 20.8953L3.51961 2.50531Z',
      key: '14ccf0',
    },
  ],
]);

export default FlashlightOff;
